<template>
    <div>
        <TopBar data-cy="component_category_topbar"></TopBar>
        <SideMenu data-cy="component_category_side_menu"></SideMenu>
        <div class="container mx-auto page" data-cy="container_category_page">
            <div class="cate-content" data-cy="container_category_content">
                <CategoryList
                        ref="cate-list"
                        :categoryConfig="categoryConfig"
                        :modalController="modalController"
                        data-cy="component_category_list"
                ></CategoryList>
            </div>
        </div>

        <ModalMaster :controller="modalController" data-cy="component_category_modal_master"></ModalMaster>
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import SideMenu from '@/components/Layout/SideMenu/SideMenu.vue';
import CategoryList from '../component/CategoryList/CategoryList.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//service
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";

export default {
    name: 'Category',
    mixins: [ModalMixin, AuthStatusMixin, LocaleMixin],
    components: {
        TopBar,
        SideMenu,
        CategoryList,
    },
    data: function() {
        return {
            categoryConfig: null,
        };
    },
    created: function() {
        this.setScrollLoadMore();
        this.initialCategory();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        initialCategory: function () {
            var configStr = ConfigManager.getCategoryMenuDev();
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig(configStr)
                .setLocale(this.localeCode)
                .create();

            this.categoryConfig = categoryConfig;
        },

        loadMore: function() {
            this.$refs['cate-list'].loadMore();
        },
    },
}
</script>
<style lang="scss" scoped>
    .cate-content {
        max-width: 500px;
        margin: auto;
        padding-top: 20px;
    }
</style>
